interface TableSkeletonProps {
  rows?: number
  columns?: number
}

// Varying flex-basis values to give natural-feeling column widths
const COL_FLEX = [
  ['basis-1/4', 'basis-1/6', 'basis-1/5', 'basis-1/8', 'basis-1/6', 'basis-1/5', 'basis-1/4'],
  ['basis-1/5', 'basis-1/4', 'basis-1/6', 'basis-1/5', 'basis-1/8', 'basis-1/4', 'basis-1/6'],
  ['basis-1/6', 'basis-1/5', 'basis-1/4', 'basis-1/6', 'basis-1/5', 'basis-1/8', 'basis-1/5'],
  ['basis-1/8', 'basis-1/6', 'basis-1/5', 'basis-1/4', 'basis-1/6', 'basis-1/5', 'basis-1/6'],
  ['basis-1/5', 'basis-1/8', 'basis-1/6', 'basis-1/5', 'basis-1/4', 'basis-1/6', 'basis-1/8'],
]

export function TableSkeleton({ rows = 8, columns = 6 }: TableSkeletonProps) {
  return (
    <div className="animate-pulse w-full">
      {/* Header row */}
      <div className="flex items-center gap-6 px-6 py-3.5 border-b border-slate-100 bg-slate-50">
        {Array.from({ length: columns }).map((_, i) => (
          <div key={i} className={`h-2.5 rounded-full bg-slate-200 flex-1 ${COL_FLEX[0][i % 7]}`} />
        ))}
      </div>

      {/* Data rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          key={rowIdx}
          className={`flex items-center gap-6 px-6 py-4 border-b border-slate-100 last:border-0 ${rowIdx % 2 === 1 ? 'bg-slate-50/40' : ''}`}
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <div
              key={colIdx}
              className={`h-3 rounded-full bg-slate-100 flex-1 ${COL_FLEX[rowIdx % COL_FLEX.length][colIdx % 7]}`}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
